import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { mobileHeader, hamburger, hamburgerBar, menuLogo } from "../menuPage.css.ts";
import topLogo from "../../../../../assets/top/logonameonly.png";
import * as sideMenuStyles from "../../Top/components/SideMenu/sideMenu.css";

const menuSections = [
  { id: 'lunchmenu', label: 'ランチ', en: 'LUNCH' },
  { id: 'dinnermenu', label: '夜ムク', en: 'DINNER' },
  { id: 'takeoutmenu', label: 'テイクアウト', en: 'TAKEOUT' },
  { id: 'reservation', label: '予約', en: 'RESERVATION', href: 'https://app.squareup.com/appointments/book/qgq7fvn533lm8i/LDWB4KMXMDB4D/start' },
  { id: 'top', label: 'トップへ', en: 'TOP' },
];

const MobileHeader: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (id: string) => {
    return location.pathname === `/${id}`;
  };

  const handleClick = (id: string, href?: string) => {
    setOpen(false);
    if (href) {
      window.location.href = href;
      return;
    }
    if (id === "top") {
      window.location.href = "/";
    } else {
      window.location.href = `/${id}`;
    }
  };

  return (
    <>
      <header className={mobileHeader}>
        <img
          src={topLogo}
          alt="キッチンムク"
          className={menuLogo}
          style={{ cursor: "pointer" }}
          onClick={() => handleClick("top")}
        />
        <div className={hamburger} onClick={() => setOpen(true)}>
          <div className={hamburgerBar} />
          <div className={hamburgerBar} />
          <div className={hamburgerBar} />
        </div>
      </header>
      <nav className={`${sideMenuStyles.menuContainer} ${open ? sideMenuStyles.menuOpen : ""}`}
        style={{ pointerEvents: open ? 'auto' : 'none' }}
      >
        <button 
          className={sideMenuStyles.closeButton}
          onClick={() => setOpen(false)}
          aria-label="メニューを閉じる"
        />
        <ul className={sideMenuStyles.menuList}>
          {menuSections.map((section) => (
            <li key={section.id} className={sideMenuStyles.menuItem}>
              <a
                href={section.href || `/${section.id}`}
                className={`${sideMenuStyles.menuLink} ${isActive(section.id) ? sideMenuStyles.active : ''}`}
                onClick={e => {
                  e.preventDefault();
                  handleClick(section.id, section.href);
                }}
              >
                {section.label}
                <span style={{ fontSize: 12, marginLeft: 8, color: '#aaa' }}>{section.en}</span>
              </a>
            </li>
          ))}
        </ul>
      </nav>
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.4)",
            zIndex: 1999,
          }}
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default MobileHeader; 